/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...



$(document).on("change",'.product-form__swatch__item [name="Stain Option"]', function() {
   var SwymThis = this;
    var SwymSelectedOption = $(SwymThis).attr('value');
    console.log("SwymSelectedOption ", SwymSelectedOption);

  
  //.media-gallery__nav .media-gallery__thumbs .thumbnail-list

    var counter = 0;
   $(document).find('.media-gallery__nav .media-gallery__thumbs .thumbnail-list .thumbnail-list__item').each(function() {
    var getEachVal = $(this).attr('data-swym-alt');
    console.log("getEachVal ", getEachVal);
     if (getEachVal === SwymSelectedOption) {
       $(this).addClass('activeSwym');
       counter = counter + 1;
       $(this).show();
     } else {
       $(this).removeClass('activeSwym');
       $(this).hide();
     }
     setTimeout ( function() {
       $('.media-gallery__nav .media-gallery__thumbs .thumbnail-list .thumbnail-list__item.onlyONe').removeClass('onlyONe');
       // $('.media-gallery__nav .media-gallery__thumbs .thumbnail-list .thumbnail-list__item.activeSwym:visible:first').addClass('your-class-thumb');
       //  $('.media-gallery__nav .media-gallery__thumbs .thumbnail-list .thumbnail-list__item.activeSwym:visible:first').trigger('click');
       $('.media-gallery__nav .media-gallery__thumbs .thumbnail-list .thumbnail-list__item.activeSwym:visible:first').find('button').trigger('click');
       $('.media-gallery__nav .media-gallery__thumbs .thumbnail-list .thumbnail-list__item.activeSwym:visible:first').addClass('onlyONe');
      }, 250);
   });


   $(document).find('.media-gallery[data-product-media-wrapper] .slick-slide').each(function() {
    var getEachVal = $(this).find('.media-gallery__wrapper').attr('data-swym-alt');
    console.log("getEachVal ", getEachVal);
     if (getEachVal === SwymSelectedOption) {
        //$(this).addClass('activeSwym');
        // $(this).show();
     } else {
       //$(this).removeClass('activeSwym');
       //$(this).hide();
     }
   });
  // console.log(counter);

  if (counter > 5) {
      $('.media-gallery__nav-item').show();
  } else {
      $('.media-gallery__nav-item').hide();
  }


  //$('.media-gallery[data-product-media-wrapper] .slick-slide.activeSwym:visible:first').addClass('your-class');
  
    // $('.js-product-slider').slick('reinit');
    // $('.js-product-slider').slick('refresh'); 
    console.log("ITG");

  

});





 var SwymThis = '.product-form__swatch__item [name="Stain Option"]';
    var SwymSelectedOption = $(SwymThis).attr('value');
    console.log("SwymSelectedOption ", SwymSelectedOption);

  
  //.media-gallery__nav .media-gallery__thumbs .thumbnail-list

    var counter = 0;
   $(document).find('.media-gallery__nav .media-gallery__thumbs .thumbnail-list .thumbnail-list__item').each(function() {
    var getEachVal = $(this).attr('data-swym-alt');
    console.log("getEachVal ", getEachVal);
     if (getEachVal === SwymSelectedOption) {
       $(this).addClass('activeSwym');
       counter = counter + 1;
       $(this).show();
     } else {
       $(this).removeClass('activeSwym');
       $(this).hide();
     }
     setTimeout ( function() {
       $('.media-gallery__nav .media-gallery__thumbs .thumbnail-list .thumbnail-list__item.onlyONe').removeClass('onlyONe');
       // $('.media-gallery__nav .media-gallery__thumbs .thumbnail-list .thumbnail-list__item.activeSwym:visible:first').addClass('your-class-thumb');
       //  $('.media-gallery__nav .media-gallery__thumbs .thumbnail-list .thumbnail-list__item.activeSwym:visible:first').trigger('click');
       $('.media-gallery__nav .media-gallery__thumbs .thumbnail-list .thumbnail-list__item.activeSwym:visible:first').find('button').trigger('click');
       $('.media-gallery__nav .media-gallery__thumbs .thumbnail-list .thumbnail-list__item.activeSwym:visible:first').addClass('onlyONe');
      }, 250);
   });


   $(document).find('.media-gallery[data-product-media-wrapper] .slick-slide').each(function() {
    var getEachVal = $(this).find('.media-gallery__wrapper').attr('data-swym-alt');
    console.log("getEachVal ", getEachVal);
     if (getEachVal === SwymSelectedOption) {
        //$(this).addClass('activeSwym');
        // $(this).show();
     } else {
       //$(this).removeClass('activeSwym');
       //$(this).hide();
     }
   });
  // console.log(counter);

  if (counter > 5) {
      $('.media-gallery__nav-item').show();
  } else {
      $('.media-gallery__nav-item').hide();
  }


  //$('.media-gallery[data-product-media-wrapper] .slick-slide.activeSwym:visible:first').addClass('your-class');
  
    // $('.js-product-slider').slick('reinit');
    // $('.js-product-slider').slick('refresh'); 
    console.log("ITG");



/****************************************************************************************************************************************************/
console.log("ITG");


    //  function findClosestOption(value, options) {
    //     var closest = options.reduce(function(prev, curr) {
    //       return (Math.abs(curr - value) < Math.abs(prev - value) ? curr : prev);
    //     });
    //     return closest.toString();
    // }


      // function findClosestOption(value, options) {
      //   // Filter options to only include multiples of the input value
      //   var multiples = options.filter(function(option) {
      //     return option % value === 0;
      //   });

      //   // If multiples are found, return the smallest one; otherwise, return the original array
      //   return multiples.length > 0 ? multiples[0].toString() : options[0].toString();
      // }

      // function findClosestOption(value, options) {
      //   // Filter options to only include multiples of the input value
      //   var multiples = options.filter(function(option) {
      //     return option <= value && option % value === 0;
      //   });

      //   // If multiples are found, return the smallest one; otherwise, return the original array
      //   return multiples.length > 0 ? multiples[0].toString() : options[0].toString();
      // }

/**

 return false;

  
  $(document).find('.SwymGrVariantPicker option').each(function() {
     var FindVariantAmount = $(this).attr('data-title');
    if (FindVariantAmount === GetAmountVal) {
     //   console.log('Changed');
        $(this).parent('select').val($(this).val());
        $(this).parent('select').trigger('change');
        return false;
    } else {
     // console.log('Not found');
    }
  });

  var Reminder = GetAmountVal % 10
  if (Reminder === 0) {
    console.log("0 REMINDER - " + Reminder);
  } else {
    console.log(" 1 REMINDER - " + Reminder);
  }



  if (GetAmountVal > 1000) {
    
  } else if (GetAmountVal > 100) {
    
  } else if (GetAmountVal > 50) {
    
  } else if (GetAmountVal > 25) {
    
  } else if (GetAmountVal > 15) {
    
  } else if (GetAmountVal > 10) {
    
  } else if (GetAmountVal > 5) {
    
  } else if (GetAmountVal > 2) {
    
  }


**/

      function findClosestOption(value, options) {
        // Filter options to only include divisors of the input value
        var divisors = options.filter(function(option) {
          return value % option === 0;
        });

        // If divisors are found, return the largest one; otherwise, return the original array
        return divisors.length > 0 ? Math.max(...divisors).toString() : options[0].toString();
      }


$(document).on('change input', '.SwymgrDonationInputBox input', function(event) {
    event.preventDefault();
    var GetAmountVal = $(this).val();


      $(document).find('.SwymGrVariantPicker option').each(function() {
       var FindVariantAmount = $(this).attr('data-title');
        if (FindVariantAmount === GetAmountVal) {
         //   console.log('Changed');
            $(this).parent('select').val($(this).val());
            $(this).parent('select').trigger('change');
            return false;
        } else {
         // console.log('Not found');
        }
      });

  
      var optionsArray = [];
      $('.SwymGrVariantPicker option').each(function() {
          optionsArray.push(parseInt($(this).attr('data-title')));
      });

      var inputValue = parseInt($(this).val());
      var closestOption = findClosestOption(inputValue, optionsArray);
      console.log('closestOption - ' + closestOption);
      $('.SwymGrVariantPicker').val(closestOption);
      $('.SwymGrVariantPicker').trigger('change');
  

      var calulatoQTY = Number(GetAmountVal) / Number($('.SwymGrVariantPicker').val());
      
      console.log('calulatoQTY - ' + calulatoQTY);

      $(document).find('.price .price__number .money').text(`$${GetAmountVal}.00`);
      $(document).find('.hidePriceSwymGr').show();
    


var  getVariantID = $('.SwymGrVariantPicker option:selected').attr('data-variant-id');
var  getVariantQty = calulatoQTY;

  
$(document).find('.SwymGrVariantID').val(getVariantID);
$(document).find('.SwymGrQty').val(getVariantQty);
  
// $(document).find('.SwymGrQty[data-variant-id="'+getVariantID+'"]').attr('data-qty', getVariantQty);

  console.log('.SwymGrQty[data-variant-id="'+getVariantID+'"]');
  
});

$(document).on('change','.SwymDonateAmountOption',function() {
  var thisVal = $(this).val();
  if (thisVal === 'other') {
    $('.SwymGrDonationWrapper').show();
  } else {
    $('.SwymGrDonationWrapper').hide();
       $('.SwymGrVariantPicker option').each(function() {
          var thisPrice = $(this).attr('data-price');
          var dataTitle = $(this).attr('data-title');
         console.log("thisVal" + thisVal + ' / ' + dataTitle);
           if (thisVal === dataTitle) {
             console.log('matched');
              var VarIdNew = $(this).attr('data-variant-id');
                $(document).find('.SwymGrVariantID').val(VarIdNew);
                $(document).find('.SwymGrQty').val(1);
                $(document).find('.price .price__number .money').text(thisPrice);
                $(document).find('.hidePriceSwymGr').show();
           }
      });


    
  }
});